export { default } from "./Montserrat40pxSemibold";
